import {TweenMax} from 'gsap';
import Swiper from 'swiper';

export default class VideoSlider {
    constructor() {
        this.swiper = document.querySelector('.swiper-container');
        this.videoWrappers = document.querySelectorAll('.js-video-slider-wrapper');

        if (this.swiper) {
            this.init()
        }

        if (this.videoWrappers.length > 0) {
            this.videoController();
        }
    }

    init() {
        let swiper = new Swiper('.swiper-container', {
            parallax: true,
            slidesPerView: 'auto',
            shortSwipes: false,
            spaceBetween: 60,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
        });

        let slides = document.querySelectorAll('.swiper-slide');

        swiper.on('transitionEnd', () => {
            for (let i = 0; i < slides.length; i++) {
                if (i !== swiper.activeIndex) {
                    slides[i].classList.remove('is-current');
                } else {
                    slides[i].classList.add('is-current');
                }

                if (slides[i].querySelector('.is-playing')) {
                    slides[i].querySelector('.js-slider-video').isPlaying = false;
                    slides[i].querySelector('.js-slider-video').removeAttribute("controls");
                    slides[i].querySelector('.js-video-slider-wrapper').classList.remove('is-playing');
                    slides[i].querySelector('.js-slider-video').pause();
                }
            }
        });
    }

    videoController() {
        for (let videoWrapper of this.videoWrappers) {
            let video = videoWrapper.querySelector('.js-slider-video');
            let playVideoBtn = videoWrapper.querySelector('.js-play-slider-video');
            video.isPlaying = false;
            playVideoBtn.addEventListener('click', () => {

                if (video.isPlaying) {
                    return;
                }

                video.setAttribute("controls", "controls");
                video.isPlaying = true;
                video.play();
                videoWrapper.classList.add('is-playing');
            });

            video.addEventListener('click', () => {
                if (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2) {
                    video.removeAttribute("controls");
                    video.isPlaying = false;
                    videoWrapper.classList.remove('is-playing');
                    video.pause();
                }
            });
        }
    }

    playPauseVideo() {
        // /  if (this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2) {
        //       this.video.removeAttribute("controls");
        //       this.isPlaying = false;
        //       this.videoWrapper.classList.remove('is-playing');
        //       this.video.pause();
        //   }
    }
}
